import L from 'leaflet';
import { isEmpty } from 'lodash';
import { getGeometry } from '../../api/Missions/mission-operations';

/**
 * Draws the mission geometry on the leaflet map.
 *
 * @param {object} arg - The object argument.
 * @param {object} arg.leafletMap - The leaflet map object.
 * @param {object} arg.mission - The mission object.
 * @param {?object} arg.drawnItems - The feature group where the geometry layers will be.
 * @param {boolean} [arg.isUpdate=false] - Flag to determine if we are doing an update.
 * @returns {object} The leaflet feature group object added to the map with the geometry layers.
 */

const drawMissionGeometry = ({ leafletMap, mission, drawnItems, isUpdate = false }) => {
  let newItemsToDraw = '';
  if (!isUpdate) {
    newItemsToDraw = new L.FeatureGroup().addTo(leafletMap);
  } else {
    drawnItems.clearLayers();
    newItemsToDraw = drawnItems;
  }

  const missionGeometry = getGeometry(mission);

  if (!isEmpty(missionGeometry)) {
    newItemsToDraw.addLayer(L.geoJSON(missionGeometry).getLayers()[0]);
  }
  return newItemsToDraw;
};

export default drawMissionGeometry;
